export enum VariableDisplay {
    NodeName,
    VariableID,
    AliasKey,
    Tag
}